import ArchetypeSeeker from './ArchetypeSeeker'

export default ArchetypeSeeker
// eslint-disable-next-line import/export
export * from './ArchetypeSeeker'
